export default __webpack_public_path__ + "static/media/percent.5d309705.svg";